import axios from "../AxiosInterCeptor/AxiosInterCeptor";
import { ToastError, ToastSuccess } from "../UiComponents/Toaster/Toast";

const URL = process.env.React_App_BaseUrl;
const GetAddOn = (data) => {
  return axios
    .get(`${URL}/addOn`, {
      headers: {
        isAscending: data.isAscending,
      },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      }
      else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const PostAddOn = (recData) => {
  return axios
    .post(`${URL}/addOn`, recData)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      }
      else {
        ToastSuccess(res.message);
        return res;
      }
    })
    .catch((error) => {
      ToastError("Please Enter All Fields");
      console.log(error);
    });
};

const UpdateAddOn = (_id, recData) => {
  return axios
    .put(`${URL}/addOn/${_id}`, recData)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      }
      else {
        ToastSuccess(res.message);
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const FilterAddOn = (recData) => {
  return axios
    .post(`${URL}/filterAddOn`, recData)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      }
      else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export { GetAddOn, PostAddOn, UpdateAddOn, FilterAddOn };
